import { Alert, Paper } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import { AlertPresets } from "../../../mantine/mantinePresets";
import { MspCategory } from "../../../utils/enums";
import type { FilterDropdownValues } from "../../FilterDropdown/FilterDropdown.types";
import type { LocationOverviewDataQueryParams } from "./LocationOverview.types";
import { DEFAULT_FILTER_VALUES } from "./LocationOverviewTable/LocationOverview.constants";
import { LocationOverviewTable } from "./LocationOverviewTable/LocationOverviewTable";
import { getLocationOverviewQueryParams } from "./utils/getLocationOverviewQueryParams";
import { useGetLocationOverviewTableData } from "./utils/useGetLocationOverviewTableData";

function LocationOverview() {
  const [selectedFilters, setSelectedFilters] = useState<FilterDropdownValues>(
    DEFAULT_FILTER_VALUES
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [queryOptions, setQueryOptions] =
    useState<LocationOverviewDataQueryParams>({
      limit: 5,
      offset: 0,
      ...getLocationOverviewQueryParams({
        categories: [],
        locationOverViewFilters: DEFAULT_FILTER_VALUES,
        searchValue: ""
      })
    });

  const { locationOverviewData, isLocationOverviewDataLoading } =
    useGetLocationOverviewTableData(queryOptions);

  useEffect(() => {
    const categories = Object.values(MspCategory).filter(
      (category) => selectedFilters[category] === true
    );

    setQueryOptions((prevQueryOptions) => ({
      ...prevQueryOptions,
      ...getLocationOverviewQueryParams({
        categories,
        locationOverViewFilters: selectedFilters,
        searchValue: globalFilter
      })
    }));
  }, [globalFilter, selectedFilters]);

  const handleFetchData = useCallback(
    (state: { page: number; pageSize: number }) => {
      const { page, pageSize } = state;

      const safePage = Math.floor(page);

      setQueryOptions((prevQueryOptions) => ({
        ...prevQueryOptions,
        limit: pageSize,
        offset: safePage * pageSize
      }));
    },
    []
  );

  return (
    <Paper>
      <Alert
        color={AlertPresets.info.color}
        icon={AlertPresets.info.icon}
        mb="lg"
      >
        Die Bewertung der Vollständigkeit (0-100%) für Lokationen erfolgt aus
        Performancegründen aktuell nur einmal täglich. Die gezeigten Werte
        können somit bis zu 24 Stunden alt sein.
      </Alert>

      <LocationOverviewTable
        data={locationOverviewData?.results || []}
        globalFilter={globalFilter}
        isLoading={isLocationOverviewDataLoading}
        numRows={locationOverviewData?.totalNumber || 0}
        pageIndex={queryOptions.offset / queryOptions.limit}
        pageSize={queryOptions.limit}
        selectedFilters={selectedFilters}
        setGlobalFilter={setGlobalFilter}
        onChangeFilters={(newFilters) => {
          setSelectedFilters(newFilters);
        }}
        onFetchData={handleFetchData}
      />
    </Paper>
  );
}

export { LocationOverview };
